import defaults from "./defaults.js";
import { rgb } from "d3-color";
/**
    A set of default color values used when assigning colors based on data.
    @param c A valid CSS color string.
    @param u An object containing overrides of the default colors.
*/ export default function(c) {
    var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var rgbColor = rgb(c);
    var yiq = (rgbColor.r * 299 + rgbColor.g * 587 + rgbColor.b * 114) / 1000;
    return yiq >= 128 ? u["dark"] || defaults["dark"] : u["light"] || defaults["light"];
}

//# sourceMappingURL=contrast.js.map